export default "__VITE_ASSET__BOUW9NES__"